// extracted by mini-css-extract-plugin
export default {"workOrderTitleCellHeader":"WorkOrderTitleCellHeaderComponent_workOrderTitleCellHeader__6fIDa"};